// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:30
import { TextPanelMessage_abstract } from './../../abstract/SagaBase/Objects/TextPanelMessage_abstract';
export class TextPanelMessage extends TextPanelMessage_abstract {}
